export const authenticate = (axiosInstance, email, externalToken) => {
  return axiosInstance.post(
    '/authenticate',
    { email },
    { headers: { 'Authorization': externalToken }}
  );
};
